




import { Component, Mixins } from 'vue-property-decorator';
import OverviewMixin from '@/mixins/OverviewMixin';
import FieldDefs from './FieldDefs';

@Component
export default class SuppliersOverview extends Mixins(OverviewMixin) {
  public tableCfg = FieldDefs;
}
